// imports for app window layout
import { useAuth0 } from '@auth0/auth0-react';
import MainWindow from '../../app_layout/main_window/MainWindow';
import ChatWindow from '../../app_layout/chat_window/ChatWindow';
import SideBar from '../../app_layout/sidebar/SideBar';
import APP_WINDOW_CONFIG from '../../app_layout/layout_config';

// imports relevant for HTTP calls
import DisplayException from '../../error_messages/DisplayException';
import CircleLoader from 'react-spinners/CircleLoader';
import {SERVER_URL, WEBSOCKET_URL} from '../../config_server_url';

// import user session information
import UserSessionContext from '../../user_session/context_user_session';

// imports this module specific
import '../../css_styles/button_styles.css'
import PaginatedTable from '../../tables/PaginatedTable';
import InfoPopup from '../../popup_windows/InfoPopup';
import DisplayStageDeleteCampaign from './DisplayStageDeleteCampaign'
import { SetSessionInfo_OnMarkCurrentOptCampaign, SetSessionInfo_OnDeleteCurrentCampaign } from '../../user_session/session_info_utils';
import { SetSessionInfo_OnDeleteCurrentProject } from '../../user_session/session_info_utils';

import { useNavigate } from 'react-router-dom';
import { useContext, useState, useEffect } from 'react';



function PageOptimizationCampaigns() {

    // ------------------ Display HTTP/Server Exceptions ---------------------------------
    const [Exception, setException] = useState(false);
    const [ExceptionMessage, setExceptionMessage] = useState('');
    // This Component requires to fetches data on first load -> setIsloading(true);
    // This Component does not fetch data on first load -> setIsloading(false);
    const [isLoading, setIsLoading] = useState(false);

    // ------------------ Load User Session Information ---------------------------------
    const usr_session_ctx = useContext(UserSessionContext);
    const { user } = useAuth0();

    const [broadcastProject, setBroadcastProject] = useState([]); //get session notifications via web sockets
    const [broadcastCampaign, setBroadcastCampaign] = useState([]); //get session notifications via web sockets

    // ------------------ Add User Session Websockets For Notification Events Across All Tenant (Workspace) Members -----------------------------
    useEffect(() => {
        // Create WebSocket connection`${SERVER_URL}/all_projects/load/`
        const ws = new WebSocket(`${WEBSOCKET_URL}/user_session/ws_project/${usr_session_ctx.uuid_tenant}/${user.sub}`);
        // Connection opened
        ws.onopen = () => {
        //   console.log(`WebSocket connection established for tenant ${usr_session_ctx.uuid_tenant}, user ${user.sub}`);
        };
        ws.onerror = (error) => {
            // console.error("WebSocket error observed:", error);
        };
        // Listen for messages
        ws.onmessage = (event) => {
        //   console.log('Message received:', event.data);
        let parser = event.data.split('__');
        let sender = parser[0]
        let type = parser[1].split('.')[1]
        let project_uuid = parser[2]
        if (type === 'ProjectDelete'){
            if(project_uuid === usr_session_ctx.session_info.uuid_current_project) {
                let new_broadcast = (<>{sender} has deleted <strong>your current project uuid:{project_uuid}</strong></>);
                usr_session_ctx.session_info = SetSessionInfo_OnDeleteCurrentProject(usr_session_ctx);
                handleUpdateUserSession()
                setBroadcastProject(prevBroadcast => [...prevBroadcast, new_broadcast]);
            }
        }
        };
        // Connection closed
        ws.onclose = () => {
        //   console.log(`WebSocket connection closed for tenant ${usr_session_ctx.uuid_tenant}, user ${user.sub}`);
        };
        // Clean up WebSocket connection when component unmounts
        return () => {
        ws.close();
        };
    }, []); // Effect runs when tenant_id or user_id changes


    useEffect(() => {
        const ws = new WebSocket(`${WEBSOCKET_URL}/user_session/ws_campaign/${usr_session_ctx.uuid_tenant}/${user.sub}`);
        ws.onopen = () => {
        //   console.log(`WebSocket connection established for tenant ${usr_session_ctx.uuid_tenant}, user ${user.sub}`);
        };
        ws.onerror = (error) => {
            // console.error("WebSocket error observed:", error);
        };
        // Listen for messages
        ws.onmessage = (event) => {
            // console.log('Message received:', event.data);
            let parser = event.data.split('__');
            let sender = parser[0]
            let type = parser[1].split('.')[1]
            let project_uuid = parser[2]
            let campaign_uuid = parser[3]
            if (project_uuid === usr_session_ctx.session_info.uuid_current_project){
                if (type === 'UpdateCampaignTitle'){
                    let new_broadcast = (<>{sender} has updated the campaign title for campaign uuid:{campaign_uuid}.</>);
                    setBroadcastCampaign(prevBroadcast => [...prevBroadcast, new_broadcast]);
                }
                if (type === 'CampaignCreate'){
                    let new_broadcast = (<>{sender} has created a new campaign uuid:{campaign_uuid}</>);
                    setBroadcastCampaign(prevBroadcast => [...prevBroadcast, new_broadcast]);
                }
                if (type === 'CampaignDelete'){
                    if(campaign_uuid === usr_session_ctx.session_info.uuid_current_opt_campaign) {
                        let new_broadcast = (<>{sender} has deleted <strong>your current campaign uuid:{campaign_uuid}</strong></>);
                        usr_session_ctx.session_info = SetSessionInfo_OnDeleteCurrentCampaign(usr_session_ctx);
                        handleUpdateUserSession()
                        setBroadcastCampaign(prevBroadcast => [...prevBroadcast, new_broadcast]);
                    }
                    else{
                        let new_broadcast = (<>{sender} has deleted campaign uuid:{campaign_uuid}</>);
                        setBroadcastCampaign(prevBroadcast => [...prevBroadcast, new_broadcast]);
                    }
                }
                if (type === 'CampaignCycleCreate'){
                    let new_broadcast = (<>{sender} has created a new cycle for campaign uuid:{campaign_uuid}</>);
                    setBroadcastCampaign(prevBroadcast => [...prevBroadcast, new_broadcast]);
                }
                if (type === 'CampaignCycleDelete'){
                    let new_broadcast = (<>{sender} has deleted a cycle for campaign uuid:{campaign_uuid}</>);
                    setBroadcastCampaign(prevBroadcast => [...prevBroadcast, new_broadcast]);
                }
                if (type === 'CampaignDataUpload'){
                    let new_broadcast = (<>{sender} has uploaded new data for campaign uuid:{campaign_uuid}</>);
                    setBroadcastCampaign(prevBroadcast => [...prevBroadcast, new_broadcast]);
                }
                if (type === 'CampaignDataRemoved'){
                    let new_broadcast = (<>{sender} has removed data from campaign uuid:{campaign_uuid}</>);
                    setBroadcastCampaign(prevBroadcast => [...prevBroadcast, new_broadcast]);
                }
            }
        };
        ws.onclose = () => {
        //   console.log(`WebSocket connection closed for tenant ${usr_session_ctx.uuid_tenant}, user ${user.sub}`);
        };
        // Clean up WebSocket connection when component unmounts
        return () => {
        ws.close();
        };
    }, []); // Effect runs when tenant_id or user_id changes



    // ------------------ General Window Layout -----------------------------
    
    const [canvasSize, setCanvasSize] = useState({width: 0, height: 0});
    const [layout, setLayout] = useState({sidebar:0, main: 0, chat: 0});
    const [toggleSideBar, setToggleSideBar] = useState(false);

    useEffect(() => {
        function handleResize() {
            let window_height = window.innerHeight;
            let window_width = window.innerWidth;
            let canvas_height = window_height - APP_WINDOW_CONFIG.OFFSET_HEADER_YPOS_PX;
            let sidebar = APP_WINDOW_CONFIG.SIDEBAR_WIDTH_PX;
            let chat = (window_width - sidebar)*APP_WINDOW_CONFIG.CHAT_WIDTH_RELATIVE;
            chat = Math.max (chat, APP_WINDOW_CONFIG.MIN_CHAT_WIDTH_PX);
            let main = window_width - sidebar - chat - APP_WINDOW_CONFIG.OFFSET_WINDOW_RIGHT_PX;
            setCanvasSize({width: window_width, height: canvas_height});
            // if currently the sidebar is not toggled, then resize the sidbar widow to toggle_size
            if(toggleSideBar){
                sidebar = APP_WINDOW_CONFIG.SIDEBAR_WIDTH_COLLAPSED_PX;
                main = window_width - sidebar - chat - APP_WINDOW_CONFIG.OFFSET_WINDOW_RIGHT_PX;
            }
            setLayout({sidebar:sidebar, main: main, chat: chat});
        }
        // Set initial height
        handleResize();
        // Add event listener to handle window resize
        window.addEventListener('resize', handleResize);
        // Remove event listener on component unmount
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [toggleSideBar]); // Empty dependency array ensures the effect only runs once


    function handleToggle() {
        // if currently the sidebar is not toggled, then resize the sidbar widow to toggle_size
        if(!toggleSideBar){
            let window_width = window.innerWidth;
            let sidebar = APP_WINDOW_CONFIG.SIDEBAR_WIDTH_COLLAPSED_PX;
            let chat = layout.chat;
            let main = window_width - sidebar - chat - APP_WINDOW_CONFIG.OFFSET_WINDOW_RIGHT_PX;
            setLayout({sidebar:sidebar, main: main, chat: chat});
        }
        else
        {
            let window_width = window.innerWidth;
            let sidebar = APP_WINDOW_CONFIG.SIDEBAR_WIDTH_PX;
            let chat = layout.chat;
            let main = window_width - sidebar - chat - APP_WINDOW_CONFIG.OFFSET_WINDOW_RIGHT_PX;
            setLayout({sidebar:sidebar, main: main, chat: chat});
        }
        setToggleSideBar(!toggleSideBar);
    }

// ------------------ Side Bar Content -----------------------------

    let sidebar = (<>
        <SideBar width={layout.sidebar} 
                 toggle={toggleSideBar} 
                 handle_toggle={handleToggle} 
                 active_link='optimization_campaigns' >
        </SideBar>
    </>)

// ------------------ Main Window Content ----------------------------

    const navigate = useNavigate();

    const [triggerReload, setTriggerReload] = useState(0)
    const [numSelected, setNumSelected] = useState(0);
    const [columnNames, setColumnNames] = useState([]);
    const [allCampaigns, setAllCampaigns] = useState([]);
    const [stagedDelete, setStagedDelete] = useState(null);
    const [numStaged, setNumStaged] = useState(0);
    const [countStaged, setCountStaged] = useState(1);
    const [titlesToRemove, setTitlesToRemove] = useState([]);
    const [alertCurrentUnderUpdate, setAlertCurrentUnderUpdate] = useState(false);


    function load_info_campaigns(){
        if (usr_session_ctx.session_info.uuid_current_project !==''){
            const prj_uuid = usr_session_ctx.session_info.uuid_current_project;
            setIsLoading(true); // Set loading state to true when fetch begins    // server retunrs -> cols about what info is shown. 
            fetch(`${SERVER_URL}/current_project/load_info_all_campaigns/`, {method: 'POST',
                                                                             headers:{'Content-Type':'application/json',
                                                                                      'uuid_tenant': usr_session_ctx.uuid_tenant},
                                                                             body:JSON.stringify(prj_uuid)})
            .then((res) => {
                if(!res.ok) {
                    throw new Error(`HTTP error ${res.status}`);
                }
                return res.json();
            })
            .then((loaded_campaigns) => {
                // load the info_type -> goes as column names for the all_projets table
                let col_names = loaded_campaigns.data.col_names;
                // add blank '' column to the list of colums -> this enables 'checkboxes' to select table entries
                col_names = [''].concat(col_names);
                setColumnNames(col_names);
                // load the actual information of all campaigns
                let campaigns_info = loaded_campaigns.data.campaigns_info;
                // need to add key 'selected: false' -> this enables 'checkboxes' to select table entries
                let all_campaigns = campaigns_info.map(campaign_info => {
                    // Create a new object containing the merged properties
                    let campaign_row = Object.assign({}, { selected: false }, campaign_info);
                    return campaign_row;
                });
                setAllCampaigns(all_campaigns)
                setIsLoading(false); 
            })
            .catch((err) => {
                setException(true);
                setIsLoading(false);
                setExceptionMessage(`HTTPException: err_msg=${err.message}`);
            });
        }
    }


    // Fetch All Projects
    useEffect(() => {
        load_info_campaigns()
    }, [usr_session_ctx.session_info.uuid_current_project, triggerReload]);



    function handleSelectCampaign(event)
    {
        let key_id = event.target.id.split('_');
        let key = key_id[0];
        let id = key_id[1];
        // update only input, if checkbox, need to get property target.checked
        let value = event.target.checked;
        let updated_allCampaigns = [...allCampaigns];
        updated_allCampaigns[id] = { ...updated_allCampaigns[id], [key]:value}; 
        setAllCampaigns(updated_allCampaigns)
        let numSelected = updated_allCampaigns.filter(row => row['selected'] === true).length;
        setNumSelected(numSelected)
    }


    function handleLoadCampaign(){
        setIsLoading(true);
        let uuid_to_load = allCampaigns.map(campaign => {
            if(campaign['selected']===true) {
                let uuid = campaign['uuid'];
                return uuid
            }
            return undefined;
        }).filter(uuid => uuid !== undefined);
        if(usr_session_ctx.session_info.on_update_campaign.uuid_experimental_setup !== '' ||
           usr_session_ctx.session_info.on_update_campaign.uuid_design_space !== '' ||
           usr_session_ctx.session_info.on_update_campaign.uuid_objective !== ''){
            setAlertCurrentUnderUpdate(true);
            setIsLoading(false);
            return 
           }

        if (uuid_to_load[0] !== usr_session_ctx.session_info.uuid_current_opt_campaign){
            usr_session_ctx.session_info = SetSessionInfo_OnMarkCurrentOptCampaign(usr_session_ctx, uuid_to_load[0]);
        }
        let session_update = {key: 'session_info', value: usr_session_ctx.session_info}

        fetch(`${SERVER_URL}/user_session/update_field/`, {method: 'PUT',
            headers:{'Content-Type':'application/json',
                     'auth0_user': user.sub,
                     'uuid_tenant': usr_session_ctx.uuid_tenant},
            body:JSON.stringify(session_update)
        })
        .then((res) => {
        if(!res.ok) {
            throw new Error(`HTTP error ${res.status}`);
        }
            return res.json();
        })
        .then((data) => {
            setIsLoading(false);
            navigate('/active_campaign_setup');
        })
            .catch((err) => {
            setException(true);
            setExceptionMessage(`HTTPException: err_msg=${err.message}`);
        });
    }


    async function handleUpdateUserSession() {
        setIsLoading(true);
        let session_update = {key: 'session_info', value: usr_session_ctx.session_info}
        fetch(`${SERVER_URL}/user_session/update_field/`, {method: 'PUT',
            headers:{'Content-Type':'application/json',
                     'auth0_user': user.sub,
                     'uuid_tenant': usr_session_ctx.uuid_tenant},
            body:JSON.stringify(session_update)
        })
        .then((res) => {
        if(!res.ok) {
            throw new Error(`HTTP error ${res.status}`);
        }
            return res.json();
        })
        .then((data) => {
            setIsLoading(false);
        })
            .catch((err) => {
            setException(true);
            setExceptionMessage(`HTTPException: err_msg=${err.message}`);
        });
   }


   function handleDeleteCampaigns(){
        let uuids_to_remove = allCampaigns.map(campaign => {
                if(campaign['selected']===true) {
                    let uuid = campaign['uuid'];
                    // if (uuid === usr_session_ctx.session_info.uuid_current_opt_campaign){
                    //     setAlertOnDeleteCurrent('You are about to delete your current campaign!')
                    // }
                    return uuid
                }
                return undefined;
            }).filter(uuid => uuid !== undefined);
        let titles_to_remove = allCampaigns.map(campaign => {
                if(campaign['selected']===true) {
                    let title = campaign['title'];
                    // if (uuid === usr_session_ctx.session_info.uuid_current_opt_campaign){
                    //     setAlertOnDeleteCurrent('You are about to delete your current campaign!')
                    // }
                    return title
                }
                return undefined;
            }).filter(uuid => uuid !== undefined);
        setTitlesToRemove(titles_to_remove);
        // send uuids of the project to remove to the backend for stageing 
        setIsLoading(true); 
        // console.log(new_project)
        // console.log(new_project)
        fetch(`${SERVER_URL}/current_project/stage_delete_campaigns/`, {method: 'POST',
                                                               headers:{'Content-Type':'application/json',
                                                                        'uuid_tenant': usr_session_ctx.uuid_tenant }, 
                                                               body:JSON.stringify(uuids_to_remove)})
        .then((res) => {
            if(!res.ok) {
                throw new Error(`HTTP error ${res.status}`);
            }
            return res.json();
        })
        .then((data) => {
            setIsLoading(false); 
            setStagedDelete(data.data)
            setNumStaged(data.data.length)
        })
        .catch((err) => {
            setIsLoading(false);
            setException(true);
            setExceptionMessage(`HTTPException: err_msg=${err.message}`);
        });
    }


    function handleCancel(){
        if(stagedDelete.length===1){
            setStagedDelete(null)
            setNumStaged(0)
            setNumSelected(0)
            setCountStaged(1)
            setTriggerReload(triggerReload+1)
            setTitlesToRemove([])
         }
        else{ 
            setStagedDelete([...stagedDelete.slice(1)])
            setTitlesToRemove([...titlesToRemove.slice(1)])
            setCountStaged(countStaged+1)}
       }
    

    async function handleDelete(){
        try{   
            setIsLoading(true);                  
            let uuids = {prj_uuid: usr_session_ctx.session_info.uuid_current_project,
                         campaign_uuid: stagedDelete[0].uuid}
           
            const response = await fetch(`${SERVER_URL}/current_project/delete_campaign/`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'auth0_user': user.sub,
                            'uuid_tenant': usr_session_ctx.uuid_tenant
                        },
                        body: JSON.stringify(uuids)
            });
            if (!response.ok) {
                throw new Error(`HTTP error ${response.status}`);
            }
            if (stagedDelete[0].uuid === usr_session_ctx.session_info.uuid_current_opt_campaign){
                usr_session_ctx.session_info = SetSessionInfo_OnDeleteCurrentCampaign(usr_session_ctx);
                await handleUpdateUserSession()
            }
            if(stagedDelete.length===1){
                setStagedDelete(null);
                setNumStaged(0);
                setCountStaged(1);
                setNumSelected(0);
                setTriggerReload(triggerReload+1);
                setTitlesToRemove([]);
            }
            else{ 
                setTitlesToRemove([...titlesToRemove.slice(1)])
                setStagedDelete([...stagedDelete.slice(1)]);
                setCountStaged(countStaged+1);
            }
            setIsLoading(false);
        } catch(err) {
            setIsLoading(false);
            setException(true);
            setExceptionMessage(`HTTPException: err_msg=${err.message}`);
        }
        setIsLoading(false);
    }

    let mainWindow = (<></>);
    let selection_panel=[];

    if(numSelected===1)
    {
        selection_panel=[{title:'Delete', action:handleDeleteCampaigns},{title:'Load', action:handleLoadCampaign}]
    }
    if (numSelected>1)
    {
        selection_panel=[{title:'Delete', action:handleDeleteCampaigns}]
    }




    if (!isLoading && !Exception && broadcastProject.length === 0 && broadcastCampaign.length === 0) { 
        // Regular Content and Logic of Main Window Goes Here
        mainWindow = (<></>);
        if (!isLoading && !Exception && stagedDelete) { 
            mainWindow = (<>
                <MainWindow width={layout.main} >
                    <DisplayStageDeleteCampaign 
                                        height = {canvasSize.height}
                                        onCancel={handleCancel} 
                                        onDelete={handleDelete} 
                                        idxStaged={countStaged}
                                        numStaged={numStaged} 
                                        toDelete={stagedDelete} 
                                        titles={titlesToRemove}
                                         />   
                </MainWindow>
            </>);
        }

        else if(alertCurrentUnderUpdate) {
            mainWindow =(<>
                <MainWindow width={layout.main} >
                        <InfoPopup ypos={'60px'} handleOk={()=>{setAlertCurrentUnderUpdate(false)}}>  
                        The active campaign is currently being updated. 
                        Please complete the update before loading another optimization campaign.
                        </InfoPopup>
                </MainWindow>
                    </>);
        }

        else {
            mainWindow = (<>
            <MainWindow width={layout.main} >
                <h3 style = {{margin:'0', marginBottom:'5px', marginTop:'20px', 'padding':'5px', position: 'relative', left:'3%', width:'94%'}} >All Campaigns</h3>
                <div style={{position: 'relative', paddingTop:'10px', left:'3%', width:'94%', height:'100%'}}>
                <PaginatedTable colNames={columnNames} 
                        tableRows={allCampaigns}
                        highlight_key = 'uuid'
                        highlight_target = {usr_session_ctx.session_info.uuid_current_opt_campaign}
                        onSelect={handleSelectCampaign} 
                        itemsPerPage={15}
                        actionsOnSelect={selection_panel}/>
                </div>
            </MainWindow>
        </>);
        }
    }


    if (!isLoading && !Exception && broadcastCampaign.length > 0){
        mainWindow = (<>
            <MainWindow width={layout.main} >
            <div style={{position: 'relative', left:'3%', width:'94%', height:'100%'}}>
                <InfoPopup ypos={'60px'} handleOk={()=>{setBroadcastCampaign(prevBroadcast => []); load_info_campaigns();} } >
                    <div style={{fontWeight:'bold', textAlign:'left'}}>Session has been updated by another user:</div>
                    <ul style={{ listStyleType: 'disc', paddingLeft: '20px', textAlign: 'left' }}>
                        {broadcastCampaign.map((item, index) => (
                        <li key={index}>{item}</li>
                        ))}
                    </ul>
                </InfoPopup>
                </div>
            </MainWindow>
            </>);
    }


    if (!isLoading && !Exception && broadcastProject.length > 0){
        mainWindow = (<>
            <MainWindow width={layout.main} >
            <div style={{position: 'relative', left:'3%', width:'94%', height:'100%'}}>
                <InfoPopup ypos={'60px'} handleOk={()=>{setBroadcastProject(prevBroadcast => []); navigate('/')} } >
                    <div style={{fontWeight:'bold', textAlign:'left'}}>Session has been updated by another user:</div>
                    <ul style={{ listStyleType: 'disc', paddingLeft: '20px', textAlign: 'left' }}>
                        {broadcastProject.map((item, index) => (
                        <li key={index}>{item}</li>
                        ))}
                    </ul>
                </InfoPopup>
                </div>
            </MainWindow>
            </>);
    }



    if (isLoading && !Exception) {   
        mainWindow = (<>
                <MainWindow width={layout.main} >
                    <div style = {{position:'absolute', top:'5px', display: 'flex', justifyContent: 'center', alignItems: 'center',  width:'100%', height:'100%', border:'1px solid black'}}>
                        <CircleLoader loading={isLoading} size={40} color='var(--aixelo-green)' />
                    </div>
                </MainWindow>
            </>);
       }

    if(Exception){
        mainWindow = (<>
                <MainWindow width={layout.main} >
                    <DisplayException>
                        {ExceptionMessage}
                    </DisplayException>  
                </MainWindow>
            </>);
    }


// ------------------ Return All Components ----------------------------

    // Show Sidebar, MainWindow and ChatWindow
    return(
        <>
        <div style={{position:'relative', display:'grid', gridTemplateColumns: 'auto auto auto', overflow: 'hidden', left:`${APP_WINDOW_CONFIG.OFFSET_WINDOW_LEFT_PX}px`, top:`${APP_WINDOW_CONFIG.OFFSET_HEADER_YPOS_PX}px`, height:canvasSize.height, width:'100%'}}>
            {sidebar}
            {mainWindow}
            <ChatWindow width={layout.chat}/>
        </div>    
        </>
    );

}


export default PageOptimizationCampaigns;